import { TFunction } from "i18next";

export type QuantityLimitReason = "at_limit" | "capped" | "reached";

export const getQuantityLimitMessage = (
  t: TFunction,
  productName: string,
  maxQty: number,
  reason: QuantityLimitReason
): string => {
  const key =
    reason === "at_limit"
      ? "salesOrder.maxQtyAtLimit"
      : reason === "capped"
        ? "salesOrder.maxQtyCapped"
        : "salesOrder.maxQtyReached";

  return t(key, {
    product: productName,
    max: maxQty,
    defaultValue:
      reason === "at_limit"
        ? `Maximum quantity for ${productName} is ${maxQty}. You already have ${maxQty} in your cart.`
        : reason === "capped"
          ? `Maximum you can order for ${productName} is ${maxQty}. Quantity was adjusted to ${maxQty}.`
          : `You reached the maximum order limit (${maxQty}) for ${productName}.`,
  });
};
